<footer class="app-footer black-bg-color mt-2">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-3 col-lg-4 mb-2">
                <img [src]="clientDetails.footer_logo" width="100" class="mb-3">
                <div class="g-txt mb-3">&copy; {{copyRightYear}} {{clientDetails?.name}} Inc. All rights reserved.</div>
                <ng-container class="d-inline" *ngIf="!route.snapshot.queryParams.user_id">
                    <a href="https://play.google.com/store/apps/details?id=com.arevea.tv" target="_blank"><img
                            [src]="assets_url + 'website/homepage/googleplay.png'" width="130px"></a>
                    <a href="https://apps.apple.com/in/app/arevea/id1535047464" target="_blank"><img
                            [src]="assets_url + 'website/homepage/appstore.png'" width="130px" class="ml-2"></a>
                </ng-container>
            </div>
            <div class="col-6 col-md-2 col-lg-2 mb-2">
                <p class="text-info">Company</p>
                <div class="pointer"> <a routerLink="/contactus" (click)="ContactUs()">Contact Us</a></div>

            </div>
            <div class="col-6 col-md-3 col-lg-2 mb-2 pl-0">
                <p class="text-info">Legal</p>
                <div class="pointer d-inline">
                    <a (click)="goToRespectiveScreen('privacypolicy')">Privacy Policy</a><br>
                    <a (click)="goToRespectiveScreen('cookiepolicy')">Cookie Policy</a><br>
                    <a (click)="goToRespectiveScreen('termsandconditions')">Terms of Service</a>
                </div>
            </div>
            <div class="col-12 col-md-2 col-lg-2">
                <p class="text-info">Follow us</p>
                <div class="pointer" *ngIf="clientDetails?.socialIcons == 1">
                    <a href="{{clientDetails.instagram}}" target="_blank"> <span class="m-icon"><img
                        src='{{assets_url + "clients/manaqi/manaqi_icons/insta.png"}}' width="20px"></span></a>
                    <a href="{{clientDetails.facebook}}" target="_blank">
                        <span class="m-icon ml-0"><img src='{{assets_url + "clients/manaqi/manaqi_icons/fb.png"}}'
                                width="20px"></span></a>
                                <a href="{{clientDetails.twitter}}" target="_blank"> <span class="m-icon"><img
                                    src='{{assets_url + "clients/manaqi/manaqi_icons/twitter.png"}}'
                                    width="20px"></span></a>
                    <a href="{{clientDetails.linkedin}}" target="_blank"> <span class="m-icon"><img
                                src='{{assets_url + "clients/manaqi/manaqi_icons/linkedin.png"}}'
                                width="20px"></span></a>
                    


                </div>
                <!-- <div class="pointer" [hidden]="clientDetails?.socialIcons == 1">
                    <a href="https://www.facebook.com/Areveatv-111754950520279/" target="_blank">
                        <app-svg [icon]="'homepage-facebook'" (click)="facebookLogo()"></app-svg>
                        </a>
                </div> -->
                <div class="pointer" [hidden]="clientDetails?.socialIcons == 1">
                    <a href="https://www.linkedin.com/company/bigbee-ai/" (click)="facebookLogo()" target="_blank">
                        <i class="fa fa-linkedin fs-20" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="col-6 col-md-2 col-lg-2 pointer" *ngIf="clientDetails?.slug != 'arevea' && clientDetails?.slug != 'bigbeeai'" [hidden]="clientDetails?.useArevea == 1" >
                <!-- <img [src]="assets_url + 'Powered by- Arevea.svg'" width="100" class="mb-3" (click)="redirectTo()"> -->
                <span class="mb-3" (click)="redirectTo()">
                    <app-svg [icon]="'powered-by-bigbee'"></app-svg>
                </span>
            </div>
        </div>
    </div>
</footer>
<!-- <footer>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 col-md-4">
                <div class="row">
                    <div class="col">
                        <div class="links">
                            <a (click)="goToRespectiveScreen('privacypolicy')">Privacy Policy</a>
                            <a (click)="goToRespectiveScreen('termsandconditions')">Terms of Service</a>
                        </div>
                    </div>
                    <div class="col">
                        <div class="links">
                            <span *ngIf="!userInfo?.signedIn">
                                <span *ngFor="let menu of menuNames">
                                    <a (click)="goToRespectiveScreen(menu)"
                                        [ngClass]="{'footerActive': router.url.includes(menu)}">{{menu}}</a>
                                </span>
                            </span>
                            <a routerLink="/aboutus" routerLinkActive="footerActive">About</a>
                            <a routerLink="/contactus" routerLinkActive="footerActive">Contact</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="getintouch">Get in touch to <a routerLink="contactus">learn more</a></div>
            </div>
            <div class="col-12 col-md-4"></div>
        </div>
        <div class="row align-items-center">
            <div class="col">
                <div>Contact</div>
                <a href="https://www.facebook.com/Areveatv-111754950520279/" target="_blank"><img
                        src="assets/website/homepage/facebook.svg" style="margin-right: 10px;"></a> -->
<!-- <a href="https://www.instagram.com/areveatv/" target="_blank"><img
                        src="assets/website/homepage/instagram.svg"></a> -->
<!-- </div>
            <div class="col text-center">Copyright 2021 Arevea Inc</div>
            <div class="col text-right">
                <img src="assets/footer-logo.svg">
            </div>
        </div>
    </div>
  
</footer> -->